
function Ticket(state, slug, action) {
  this.state = state;
  this.slug = slug;
  this.action = action;
  this.tickets = _.filter(state, s => { return s.quantity > 0 });
  this.groupQty = 10;
  this.num = !!(slug && slug.includes('4')) ? 0 : 1;
  // const test = _.find(state, ['id', 'adult_gift']);
  // console.log('test.quantity', test.quantity);
  // console.log('STATE', state);

  this.packages = {
    adult_package: [
      {
        id: 'adult',
        quantity: 1
      },
      {
        id: 'guidebook',
        quantity: 1
      },
      {
        id: 'digital_guidebook',
        quantity: 1
      }
    ],
    child_package: [
      {
        id: 'child',
        quantity: 1
      },
      {
        id: 'guidebook',
        quantity: 1
      },
      {
        id: 'digital_guidebook',
        quantity: 1
      }
    ],
    family_2_2: [
      {
        id: 'adult',
        quantity: 2
      },
      {
        id: 'child',
        quantity: 2
      }
    ],
    family_1_3: [
      {
        id: 'adult',
        quantity: 1
      },
      {
        id: 'child',
        quantity: 3
      }
    ],
    family_2_2_gift: [
      {
        id: 'adult_gift',
        quantity: 2
      },
      {
        id: 'child_gift',
        quantity: 2
      }
    ],
    family_1_3_gift: [
      {
        id: 'adult_gift',
        quantity: 1
      },
      {
        id: 'child_gift',
        quantity: 3
      }
    ]
  };
  this.breakOuts = {
    adult_package: [
      {
        id: 'adult',
        quantity: 1
      },
      {
        id: 'package',
        quantity: 1
      }
    ],
    child_package: [
      {
        id: 'child',
        quantity: 1
      },
      {
        id: 'package',
        quantity: 1
      }
    ],
    family_2_2: [
      {
        id: 'adult',
        quantity: 2
      },
      {
        id: 'child',
        quantity: 2
      }
    ],
    family_1_3: [
      {
        id: 'adult',
        quantity: 1
      },
      {
        id: 'child',
        quantity: 3
      }
    ],
    family_2_2_gift: [
      {
        id: 'adult_gift',
        quantity: 2
      },
      {
        id: 'child_gift',
        quantity: 2
      }
    ],
    family_1_3_gift: [
      {
        id: 'adult_gift',
        quantity: 1
      },
      {
        id: 'child_gift',
        quantity: 3
      }
    ]
  };
  this.min = {
    child_0_4: [
      {
        ids: ['adult'],
        quantity: 1
      }
    ],
    parking: [
      {
        ids: ['adult'],
        quantity: 1
      }
    ],
    group: [
      {
        ids: ['adult', 'child'],
        quantity: 10
      }
    ]
  };
}

Ticket.prototype.clientState = function() {
  let pkg;
  const standardTicket = this.state.map(s => {
    switch (this.slug) {
      case 'package':
        if (s.id === 'adult' && s.quantity > 0 && !pkg) {
          pkg = 'adult_package';
          s.quantity--;

        } else if (s.id === 'child' && s.quantity > 0 && !pkg) {
          pkg = 'child_package';
          s.quantity--;
        } else if (pkg && pkg === s.id) {
          s.quantity++;
        }
        break;
      case 'gift_box':
      case 'winter_box':
      case 'wallet':
        const gifts = ['gift_box', 'winter_box', 'wallet'];
        if (gifts.includes(s.id)) s.quantity = 0;
        if (this.slug === s.id && this.action === 'add') s.quantity = 1;
        if (this.slug === s.id && this.action === 'subtract') s.quantity = 0;
        break;
      case s.id:
        console.log('s.id', s.id);
        console.log('action', this.action);
        if (this.action === 'add') s.quantity++;
        if (this.action === 'subtract') s.quantity--;
        if (this.action === 'remove') s.quantity = 0;
        break;
      default:
        break;
    }
    return s;
  });

  console.log('standardTicket', standardTicket);
  const convert = this.convert(standardTicket);
  const isGroup = (this.totalPeople() >= 10);
  // console.log('this.hasGiftAddon()', this.hasGiftAddon());
  const isBox = !!(this.slug && this.slug.includes('box') && !this.hasGiftAddon());
  const noAdult = (this.adultNumber(standardTicket) === 0);

  Ticket.prototype.isGroup = isGroup;
  if (!convert && !isGroup && !isBox && !noAdult) return standardTicket;

  if (convert) { // family & packages
    Ticket.prototype.converted = convert;
    // console.log('convert', convert);
    return this.state.map(s => {
      if (s.id === convert.name) s.quantity++;
      convert.qty.forEach(q => {
        if (q.id === s.id) {
          s.quantity = s.quantity - q.quantity;
        }
      });
      return s;
    });
  }
  if (isGroup) {
    const toConvert = ['adult', 'child'];
    const adultQty = _.find(this.state, ['id', 'adult']).quantity;
    const childQty = _.find(this.state, ['id', 'child']).quantity;
    return this.state.map(s => {
      if (toConvert.includes(s.id)) s.quantity = 0;
      if (s.id === 'group_adult') s.quantity = adultQty;
      if (s.id === 'group_child') s.quantity = childQty;
      return s;
    });
  }
  if (isBox) {
    // console.log('isBox');
    const toConvert = ['adult_gift', 'child_gift', 'family_2_2_gift', 'family_1_3_gift'];
    let converted = this.state;
    let action = this.action
    toConvert.forEach(c => {
      const toBox = c + '_box';
      const transferred = action === 'add' ? transferredState(this.state, c, toBox) : transferredState(this.state, toBox, c);
      Object.assign(converted, transferred);
    });
    // console.log('converted', converted);
    return converted;
  }
  const adultGroupQty = _.find(this.state, ['id', 'group_adult']);
  if (adultGroupQty) {
    const childGroupQty = _.find(this.state, ['id', 'group_child']).quantity;
    if (!isGroup && adultGroupQty.quantity > 0) {
      // convert group tickets to regular
      const toConvertBack = ['group_adult', 'group_child'];
      return this.state.map(s => {
        if (toConvertBack.includes(s.id)) s.quantity = 0;
        if (s.id === 'adult') s.quantity = adultGroupQty;
        if (s.id === 'child') s.quantity = childGroupQty;
        return s;
      });
    }
  }
  if (noAdult) {
    return this.state.map(s => {
      if (s.id.includes('4')) s.quantity = 0;
      return s;
    });
  }
}
const transferredState = function(arr, from, to) {
  const fromQty = _.find(arr, ['id', from]).quantity;
  return arr.map(a => {
    if (a.id === from) a.quantity = 0;
    if (a.id === to) a.quantity = fromQty;
    return a;
  })
}
function hasMin(firstObjValue, secondObjValue) {
  return firstObjValue.id === secondObjValue.id && firstObjValue.quantity >= secondObjValue.quantity;
}
Ticket.prototype.convert = function(newState) {
  let ticketMatch = null;
  const tickets = newState ? _.filter(newState, function(s) { return s.quantity > 0 }) : this.tickets;
  // console.log('TICKETS', tickets);
  _.forEach(this.packages, function(v, k) {
    // console.log(k);
    // console.log('v', v);
    const ticketsToMatch = v.filter(item => {
      return tickets.some(s => {
        return item.id === s.id && s.quantity >= item.quantity;
      })
    });
    // console.log('ticketsToMatch', ticketsToMatch);
    const match = _.isMatchWith(ticketsToMatch, v, hasMin);
    // console.log('match', match);
    // console.log('------');
    if (match) {
      ticketMatch = {
        name: k,
        qty: v
      };
      return false;
    }
  });
  return ticketMatch;
};

Ticket.prototype.convertedToGroup = function() {
  if (this.totalPeople() >= 10) {
    const converted = _.find(this.state, ['id', 'adult']);
    if (converted.quantity > 0) return true;
  }
  return false;
}
Ticket.prototype.adultNumber = function(tickets) {
  const t = tickets ? tickets : this.tickets;
  return _.reduce(t, (result, value) => {
    if (value.id.includes('adult') || value.id.includes('deluxe_tour') || value.id.includes('family_1_3')) {
      return result + value.quantity;
    } else if (value.id.includes('family_2_2')) {
      return result + (value.quantity * 2);
    }
    return result;
  }, 0);
}
Ticket.prototype.childNumber = function(tickets) {
  const t = tickets ? tickets : this.tickets;
  return _.reduce(t, (result, value) => {
    if (value.id.includes('child')) {
      return result + value.quantity;
    } else if (value.id.includes('family_2_2')) {
      return result + (value.quantity * 2);
    } else if (value.id.includes('family_1_3')) {
      return result + (value.quantity * 3);
    }
    return result;
  }, 0);
}
Ticket.prototype.singleCount = function() {
  return _.reduce(this.tickets, (result, value) => {
    if (value.id === 'adult' || value.id === 'child') {
      return result + value.quantity;
    }
    return result;
  }, 0);
}
Ticket.prototype.totalPeople = function() {
  return _.reduce(this.state, function(result, value) {
    const numPeople = !!((value.id.includes('adult') || value.id.includes('child')) && !value.id.includes('4')) ? value.quantity : value.id.includes('family') ? 4 * value.quantity : 0;
    return result + numPeople;
  }, 0);
};
Ticket.prototype.totalTickets = function() {
  return _.reduce(this.state, function(result, value) {
    return result + value.quantity;
  }, 0);
};
Ticket.prototype.default = function() {
  return this.state.map(s => {
    if (s.id === 'adult') s.quantity = 2;
    else s.quantity = 0;
    return s;
  });
};
Ticket.prototype.breakOut = function() {
  return this.state.map(t => {
    this.breakOuts[this.slug].forEach(p => {
      if (p.id === t.slug) t.qty = t.qty + p.quantity;
    });
    return t;
  });
}
Ticket.prototype.combineGuidebooks = function() {
  return this.state.map(t => {
    if (t.slug === 'guidebook') t.qty--;
    if (t.slug === 'digital_guidebook') t.qty--;
    if (t.slug === 'package') t.qty++;
  });
}
Ticket.prototype.hasGiftAddon = function() {
  return this.state.some(t => {
    if (t.id.includes('box') || t.id.includes('wallet')) {
      return t.quantity > 0;
    }
  });
}

/********/
Ticket.prototype.gift = function() {
  return this.state.map(s => {
    if (s.id === 'adult_gift') s.quantity = 2;
    else s.quantity = 0;
    return s;
  });
};
Ticket.prototype.giftBox = function() {
  return state.map(s => {
    switch (s.id) {
      case 'adult_gift_box':
        if (action === 'add' && s.quantity === 0) {
          s.quantity = state[indexes.adultGift].quantity;
          state[indexes.adultGift].quantity = 0;
        } else if (action === 'subtract') {
          state[indexes.adultGift].quantity = s.quantity;
          state[indexes.adultGiftBox].quantity = 0;
        }
        break;
      case 'child_gift_box':
        if (action === 'add' && s.quantity === 0) {
          s.quantity = state[indexes.childGift].quantity;
          state[indexes.childGift].quantity = 0;
        } else if (action === 'subtract') {
          state[indexes.childGift].quantity = s.quantity;
          state[indexes.childGiftBox].quantity = 0;
        }
        break;
      case 'child_0_4_gift_box':
        if (action === 'add' && s.quantity === 0) {
          s.quantity = state[indexes.child2Gift].quantity;
          state[indexes.child2Gift].quantity = 0;
        } else if (action === 'subtract') {
          state[indexes.child2Gift].quantity = s.quantity;
          state[indexes.child2GiftBox].quantity = 0;
        }
        break;
      case 'family_2_2_gift_box':
        if (action === 'add' && s.quantity === 0) {
          s.quantity = state[indexes.family1Gift].quantity;
          state[indexes.family1Gift].quantity = 0;
        } else if (action === 'subtract') {
          state[indexes.family1Gift].quantity = s.quantity;
          state[indexes.family1GiftBox].quantity = 0;
        }
        break;
      case 'family_1_3_gift_box':
        if (action === 'add' && s.quantity === 0) {
          s.quantity = state[indexes.family2Gift].quantity;
          state[indexes.family2Gift].quantity = 0;
        } else if (action === 'subtract') {
          state[indexes.family2Gift].quantity = s.quantity;
          state[indexes.family2GiftBox].quantity = 0;
        }
        break;
      default:
        break;
    }
    return s;
  });
};

Ticket.prototype.group = function() {
  console.log('processGroup', processGroup);

  var tqAdultTix = _.find(tqArr, t => t.id === 'adult');
  var tqChildTix = _.find(tqArr,t => t.id === 'child');
  var groupAdultTix = _.find(tqArr,t => t.id === 'group_adult');
  var groupChildTix = _.find(tqArr,t => t.id === 'group_child');
  tqAdultTix.quantity = groupAdultTix.quantity;
  tqChildTix.quantity = groupChildTix.quantity;
  groupAdultTix.quantity = 0;
  groupChildTix.quantity = 0;
  tqArr = _.union(tqArr, tqAdultTix, tqChildTix, groupAdultTix, groupChildTix);
  console.log('tqArr', tqArr);
  return tqArr;
};
Ticket.prototype.max = function() {
  return this.adult + ', ' + this.child;
};

export default Ticket;
